// src/app/core/interceptors/loader.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { defer, finalize, Observable } from 'rxjs';
import { LoaderService } from '../loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private loader: LoaderService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.get('X-Skip-Loader') === 'true') {
      return next.handle(req.clone({
        headers: req.headers.delete('X-Skip-Loader'),
      }));
    }

    return defer(() => {
      this.activeRequests++;
      this.loader.show();

      return next.handle(req).pipe(
        finalize(() => {
          this.activeRequests = Math.max(0, this.activeRequests - 1);

          if (this.activeRequests === 0) {
            this.loader.hide();
          }
        })
      );
    });
  }
}
